Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMap = void 0;
const index_1 = require("./index");
exports.IconMap = {
    activity: index_1.SvgActivity,
    airplay: index_1.SvgAirplay,
    'alert-circle': index_1.SvgAlertCircle,
    'alert-octagon': index_1.SvgAlertOctagon,
    'alert-triangle': index_1.SvgAlertTriangle,
    'align-center': index_1.SvgAlignCenter,
    'align-justify': index_1.SvgAlignJustify,
    'align-left': index_1.SvgAlignLeft,
    'align-right': index_1.SvgAlignRight,
    anchor: index_1.SvgAnchor,
    aperture: index_1.SvgAperture,
    archive: index_1.SvgArchive,
    'arrow-down-circle': index_1.SvgArrowDownCircle,
    'arrow-down-left': index_1.SvgArrowDownLeft,
    'arrow-down-right': index_1.SvgArrowDownRight,
    'arrow-down': index_1.SvgArrowDown,
    'arrow-left-circle': index_1.SvgArrowLeftCircle,
    'arrow-left': index_1.SvgArrowLeft,
    'arrow-right-circle': index_1.SvgArrowRightCircle,
    'arrow-right': index_1.SvgArrowRight,
    'arrow-up-circle': index_1.SvgArrowUpCircle,
    'arrow-up-left': index_1.SvgArrowUpLeft,
    'arrow-up-right': index_1.SvgArrowUpRight,
    'arrow-up': index_1.SvgArrowUp,
    'at-sign': index_1.SvgAtSign,
    award: index_1.SvgAward,
    'bar-chart-2': index_1.SvgBarChart2,
    'bar-chart': index_1.SvgBarChart,
    'battery-charging': index_1.SvgBatteryCharging,
    battery: index_1.SvgBattery,
    'bell-off': index_1.SvgBellOff,
    bell: index_1.SvgBell,
    bluetooth: index_1.SvgBluetooth,
    bold: index_1.SvgBold,
    'book-open': index_1.SvgBookOpen,
    book: index_1.SvgBook,
    bookmark: index_1.SvgBookmark,
    box: index_1.SvgBox,
    briefcase: index_1.SvgBriefcase,
    calendar: index_1.SvgCalendar,
    'camera-off': index_1.SvgCameraOff,
    camera: index_1.SvgCamera,
    cast: index_1.SvgCast,
    'check-circle': index_1.SvgCheckCircle,
    'check-square': index_1.SvgCheckSquare,
    check: index_1.SvgCheck,
    'chevron-down': index_1.SvgChevronDown,
    'chevron-left': index_1.SvgChevronLeft,
    'chevron-right': index_1.SvgChevronRight,
    'chevron-up': index_1.SvgChevronUp,
    'chevrons-down': index_1.SvgChevronsDown,
    'chevrons-left': index_1.SvgChevronsLeft,
    'chevrons-right': index_1.SvgChevronsRight,
    'chevrons-up': index_1.SvgChevronsUp,
    chrome: index_1.SvgChrome,
    circle: index_1.SvgCircle,
    clipboard: index_1.SvgClipboard,
    clock: index_1.SvgClock,
    'cloud-drizzle': index_1.SvgCloudDrizzle,
    'cloud-lightning': index_1.SvgCloudLightning,
    'cloud-off': index_1.SvgCloudOff,
    'cloud-rain': index_1.SvgCloudRain,
    'cloud-snow': index_1.SvgCloudSnow,
    cloud: index_1.SvgCloud,
    code: index_1.SvgCode,
    codepen: index_1.SvgCodepen,
    codesandbox: index_1.SvgCodesandbox,
    coffee: index_1.SvgCoffee,
    columns: index_1.SvgColumns,
    command: index_1.SvgCommand,
    compass: index_1.SvgCompass,
    copy: index_1.SvgCopy,
    'corner-down-left': index_1.SvgCornerDownLeft,
    'corner-down-right': index_1.SvgCornerDownRight,
    'corner-left-down': index_1.SvgCornerLeftDown,
    'corner-left-up': index_1.SvgCornerLeftUp,
    'corner-right-down': index_1.SvgCornerRightDown,
    'corner-right-up': index_1.SvgCornerRightUp,
    'corner-up-left': index_1.SvgCornerUpLeft,
    'corner-up-right': index_1.SvgCornerUpRight,
    cpu: index_1.SvgCpu,
    'credit-card': index_1.SvgCreditCard,
    crop: index_1.SvgCrop,
    crosshair: index_1.SvgCrosshair,
    database: index_1.SvgDatabase,
    delete: index_1.SvgDelete,
    disc: index_1.SvgDisc,
    'dollar-sign': index_1.SvgDollarSign,
    'download-cloud': index_1.SvgDownloadCloud,
    download: index_1.SvgDownload,
    droplet: index_1.SvgDroplet,
    'edit-2': index_1.SvgEdit2,
    'edit-3': index_1.SvgEdit3,
    edit: index_1.SvgEdit,
    'external-link': index_1.SvgExternalLink,
    'eye-off': index_1.SvgEyeOff,
    eye: index_1.SvgEye,
    facebook: index_1.SvgFacebook,
    'fast-forward': index_1.SvgFastForward,
    feather: index_1.SvgFeather,
    figma: index_1.SvgFigma,
    'file-minus': index_1.SvgFileMinus,
    'file-plus': index_1.SvgFilePlus,
    'file-text': index_1.SvgFileText,
    file: index_1.SvgFile,
    film: index_1.SvgFilm,
    filter: index_1.SvgFilter,
    flag: index_1.SvgFlag,
    'folder-minus': index_1.SvgFolderMinus,
    'folder-plus': index_1.SvgFolderPlus,
    folder: index_1.SvgFolder,
    framer: index_1.SvgFramer,
    frown: index_1.SvgFrown,
    gift: index_1.SvgGift,
    'git-branch': index_1.SvgGitBranch,
    'git-commit': index_1.SvgGitCommit,
    'git-merge': index_1.SvgGitMerge,
    'git-pull-request': index_1.SvgGitPullRequest,
    github: index_1.SvgGithub,
    gitlab: index_1.SvgGitlab,
    globe: index_1.SvgGlobe,
    grid: index_1.SvgGrid,
    'hard-drive': index_1.SvgHardDrive,
    hash: index_1.SvgHash,
    headphones: index_1.SvgHeadphones,
    heart: index_1.SvgHeart,
    'help-circle': index_1.SvgHelpCircle,
    hexagon: index_1.SvgHexagon,
    home: index_1.SvgHome,
    image: index_1.SvgImage,
    inbox: index_1.SvgInbox,
    info: index_1.SvgInfo,
    instagram: index_1.SvgInstagram,
    italic: index_1.SvgItalic,
    key: index_1.SvgKey,
    layers: index_1.SvgLayers,
    layout: index_1.SvgLayout,
    'life-buoy': index_1.SvgLifeBuoy,
    'link-2': index_1.SvgLink2,
    link: index_1.SvgLink,
    linkedin: index_1.SvgLinkedin,
    list: index_1.SvgList,
    loader: index_1.SvgLoader,
    lock: index_1.SvgLock,
    'log-in': index_1.SvgLogIn,
    'log-out': index_1.SvgLogOut,
    mail: index_1.SvgMail,
    'map-pin': index_1.SvgMapPin,
    map: index_1.SvgMap,
    'maximize-2': index_1.SvgMaximize2,
    maximize: index_1.SvgMaximize,
    meh: index_1.SvgMeh,
    menu: index_1.SvgMenu,
    'message-circle': index_1.SvgMessageCircle,
    'message-square': index_1.SvgMessageSquare,
    'mic-off': index_1.SvgMicOff,
    mic: index_1.SvgMic,
    'minimize-2': index_1.SvgMinimize2,
    minimize: index_1.SvgMinimize,
    'minus-circle': index_1.SvgMinusCircle,
    'minus-square': index_1.SvgMinusSquare,
    minus: index_1.SvgMinus,
    monitor: index_1.SvgMonitor,
    moon: index_1.SvgMoon,
    'more-horizontal': index_1.SvgMoreHorizontal,
    'more-vertical': index_1.SvgMoreVertical,
    'mouse-pointer': index_1.SvgMousePointer,
    move: index_1.SvgMove,
    music: index_1.SvgMusic,
    'navigation-2': index_1.SvgNavigation2,
    navigation: index_1.SvgNavigation,
    octagon: index_1.SvgOctagon,
    package: index_1.SvgPackage,
    paperclip: index_1.SvgPaperclip,
    'pause-circle': index_1.SvgPauseCircle,
    pause: index_1.SvgPause,
    'pen-tool': index_1.SvgPenTool,
    percent: index_1.SvgPercent,
    'phone-call': index_1.SvgPhoneCall,
    'phone-forwarded': index_1.SvgPhoneForwarded,
    'phone-incoming': index_1.SvgPhoneIncoming,
    'phone-missed': index_1.SvgPhoneMissed,
    'phone-off': index_1.SvgPhoneOff,
    'phone-outgoing': index_1.SvgPhoneOutgoing,
    phone: index_1.SvgPhone,
    'pie-chart': index_1.SvgPieChart,
    'play-circle': index_1.SvgPlayCircle,
    play: index_1.SvgPlay,
    'plus-circle': index_1.SvgPlusCircle,
    'plus-square': index_1.SvgPlusSquare,
    plus: index_1.SvgPlus,
    pocket: index_1.SvgPocket,
    power: index_1.SvgPower,
    printer: index_1.SvgPrinter,
    radio: index_1.SvgRadio,
    'refresh-ccw': index_1.SvgRefreshCcw,
    'refresh-cw': index_1.SvgRefreshCw,
    repeat: index_1.SvgRepeat,
    rewind: index_1.SvgRewind,
    'rotate-ccw': index_1.SvgRotateCcw,
    'rotate-cw': index_1.SvgRotateCw,
    rss: index_1.SvgRss,
    save: index_1.SvgSave,
    scissors: index_1.SvgScissors,
    search: index_1.SvgSearch,
    send: index_1.SvgSend,
    server: index_1.SvgServer,
    settings: index_1.SvgSettings,
    'share-2': index_1.SvgShare2,
    share: index_1.SvgShare,
    'shield-off': index_1.SvgShieldOff,
    shield: index_1.SvgShield,
    'shopping-bag': index_1.SvgShoppingBag,
    'shopping-cart': index_1.SvgShoppingCart,
    shuffle: index_1.SvgShuffle,
    sidebar: index_1.SvgSidebar,
    'skip-back': index_1.SvgSkipBack,
    'skip-forward': index_1.SvgSkipForward,
    slack: index_1.SvgSlack,
    slash: index_1.SvgSlash,
    sliders: index_1.SvgSliders,
    smartphone: index_1.SvgSmartphone,
    smile: index_1.SvgSmile,
    speaker: index_1.SvgSpeaker,
    square: index_1.SvgSquare,
    star: index_1.SvgStar,
    'stop-circle': index_1.SvgStopCircle,
    sun: index_1.SvgSun,
    sunrise: index_1.SvgSunrise,
    sunset: index_1.SvgSunset,
    tablet: index_1.SvgTablet,
    tag: index_1.SvgTag,
    target: index_1.SvgTarget,
    terminal: index_1.SvgTerminal,
    thermometer: index_1.SvgThermometer,
    'thumbs-down': index_1.SvgThumbsDown,
    'thumbs-up': index_1.SvgThumbsUp,
    'toggle-left': index_1.SvgToggleLeft,
    'toggle-right': index_1.SvgToggleRight,
    tool: index_1.SvgTool,
    'trash-2': index_1.SvgTrash2,
    trash: index_1.SvgTrash,
    trello: index_1.SvgTrello,
    'trending-down': index_1.SvgTrendingDown,
    'trending-up': index_1.SvgTrendingUp,
    triangle: index_1.SvgTriangle,
    truck: index_1.SvgTruck,
    tv: index_1.SvgTv,
    twitch: index_1.SvgTwitch,
    twitter: index_1.SvgTwitter,
    type: index_1.SvgType,
    umbrella: index_1.SvgUmbrella,
    underline: index_1.SvgUnderline,
    unlock: index_1.SvgUnlock,
    'upload-cloud': index_1.SvgUploadCloud,
    upload: index_1.SvgUpload,
    'user-check': index_1.SvgUserCheck,
    'user-minus': index_1.SvgUserMinus,
    'user-plus': index_1.SvgUserPlus,
    'user-x': index_1.SvgUserX,
    user: index_1.SvgUser,
    users: index_1.SvgUsers,
    'video-off': index_1.SvgVideoOff,
    video: index_1.SvgVideo,
    voicemail: index_1.SvgVoicemail,
    'volume-1': index_1.SvgVolume1,
    'volume-2': index_1.SvgVolume2,
    'volume-x': index_1.SvgVolumeX,
    volume: index_1.SvgVolume,
    watch: index_1.SvgWatch,
    'wifi-off': index_1.SvgWifiOff,
    wifi: index_1.SvgWifi,
    wind: index_1.SvgWind,
    'x-circle': index_1.SvgXCircle,
    'x-octagon': index_1.SvgXOctagon,
    'x-square': index_1.SvgXSquare,
    x: index_1.SvgX,
    youtube: index_1.SvgYoutube,
    'zap-off': index_1.SvgZapOff,
    zap: index_1.SvgZap,
    'zoom-in': index_1.SvgZoomIn,
    'zoom-out': index_1.SvgZoomOut,
};
//# sourceMappingURL=iconMap.js.map